<ul class="ac-tabs" *ngIf="!useUnderlineSkin && tabsWithRoutes.length > 1">
	<li *ngFor="let tab of tabsWithRoutes">
		<a
			[routerLink]="[tab.route]"
			[queryParams]="queryParams"
			class="text-16"
			[routerLinkActive]="'active text-bold'"
			[routerLinkActiveOptions]="{ __change_detection_hack__: queryParams, exact: false }"
			[attr.data-cy]="[tab.route]"
			[dcrHTMLKey]="tab.label.dcrKey"
		>
			<span>{{ tab.label.dcrValue }}</span>
		</a>
	</li>
</ul>

<nav class="tabs" *ngIf="useUnderlineSkin && tabsWithRoutes.length > 1">
	<a
		*ngFor="let tab of tabsWithRoutes; index as i"
		[routerLink]="[tab.route]"
		[routerLinkActive]="'active text-bold'"
		[routerLinkActiveOptions]="{ __change_detection_hack__: queryParams, exact: false }"
		[queryParams]="queryParams"
		class="tab text-16 d-inline-block underline"
		[attr.data-cy]="[tab.route]"
		[dcrHTMLKey]="tab.label.dcrKey"
	>
		<span class="icon-caption">{{ tab.label.dcrValue }}</span>
	</a>
</nav>
